import { css } from "@compiled/react";

import Story16Icon from "@atlaskit/icon-object/glyph/story/16";

type Story16IconCustomProps = {
    readonly primaryColor: string;
    readonly label: string;
};

export const Story16IconCustom = ({
    primaryColor,
    label
}: Story16IconCustomProps) => {
    const colorOverride = css({
        path: {
            fill: primaryColor
        }
    });

    return (
        <div css={colorOverride}>
            <Story16Icon label={label} />
        </div>
    );
};
